var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCancelAllowed)?_c('v-btn',{staticClass:"mr-1",style:(_vm.themeInverted),attrs:{"text":_vm.flat,"title":"Cancel Order","outlined":""},on:{"click":function($event){return _vm.cancelOrder()}}},[_vm._v("CANCEL ORDER")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }